var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 143.994,
    viewBox: "0 0 150 143.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Animal",
    transform: "translate(-23.957 -25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(23.957 25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M98.957,100.323c22.9,0,55.236,45.731,43,61.613s-22.159,0-43,0-30.765,15.882-43,0S76.058,100.323,98.957,100.323ZM56.628,120.564C47.673,125.325,34.9,118.818,28.1,106.03S23.05,79.015,32,74.254,53.73,76,60.529,88.788,65.582,115.8,56.628,120.564ZM81.765,80.54C71.108,83.2,59.392,73.012,55.6,57.792s1.769-29.713,12.426-32.37S90.4,32.949,94.191,48.169,92.423,77.882,81.765,80.54Zm59.521,40.024c-8.954-4.761-10.7-18.987-3.9-31.775s19.57-19.295,28.525-14.534,10.7,18.987,3.9,31.775S150.241,125.325,141.287,120.564ZM116.149,80.54c-10.658-2.657-16.221-17.15-12.426-32.37s15.511-25.4,26.168-22.748,16.221,17.15,12.426,32.37S126.807,83.2,116.149,80.54Z",
    transform: "translate(-23.957 -25)",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimal);
export default __webpack_public_path__ + "static/media/Animal.1ec1f2bac56f6bbe9ba667aa64625e16.svg";
export { ForwardRef as ReactComponent };